import React, { useContext, useState } from "react";

const themeContext = React.createContext();
export const ThemeStore = (props) => {
  const initialState = {
    headerBackColor: "#00101f", //#004d00
    purposeBackColor: "#00101f",
    footerBackColor: "#00101f",
    columnBackColor: "#00101f",
    column1title: "МЭДЭЭЛЭЛ",
    column2title: "ФОТО МЭДЭЭ",
    column3title: "ЗАР МЭДЭЭ",
  };
  const [state, setState] = useState(initialState);
  return (
    <themeContext.Provider value={{ state, setState }}>
      {props.children}
    </themeContext.Provider>
  );
};
export default themeContext;
